// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 995) return "shell/modern_shell.css?cacheBreaker=6b149f76f195ea339043";
	if (chunkId === 179) return "modules/modern_prismjs-179.css?cacheBreaker=b12127ee06be5a35313b";
	if (chunkId === 632) return "modules/modern_externalAuth-632.css?cacheBreaker=4972dfa7f5dc949ca4a0";
	if (chunkId === 76) return "designer/modern_designer.css?cacheBreaker=fde8b546e6cae3e75e9f";
	if (chunkId === 741) return "modules/modern_741-741.css?cacheBreaker=22c9091364bf53b5474f";
	if (chunkId === 212) return "modules/modern_212-212.css?cacheBreaker=a99485964f9411c9568a";
	if (chunkId === 433) return "modules/modern_433-433.css?cacheBreaker=4a8101a0813df1ba77eb";
	if (chunkId === 517) return "modules/modern_calendar-517.css?cacheBreaker=6ef3d200cf9cefb53559";
	// return url for filenames based on template
	return undefined;
};